type StaffLine = {
  staff_name?: string | null;
  line_name?: string | null;
  line_code?: string | null;
};

export const getStaffDisplayName = (line: StaffLine): string =>
  line.staff_name || line.line_name || line.line_code || "-";

